import { Box, Typography } from "@mui/material";
import CopyCitationButton from "@/src/components/common/copy-citation-button/copy-citation-button";
import SpanTypography from "@/src/mui-custom/typography/span-typography/span-typography";
import Panel from "@/src/components/common/broadsheet/panel";

function getInitials(name: string) {
  return name
    .trim()
    .split(/\s+/)
    .map((word: string) =>
      word && word.length > 0 ? word[0].toUpperCase() : "",
    )
    .join(" ");
}

const HowToCite = ({
  howTociteDictionary,
  data,
}: {
  howTociteDictionary: string;
  data: any;
}) => (
  <Panel
    role="doc-credit"
    tone="custom.kicker"
    sx={{
      my: 1,
      "& span": { fontSize: "0.875rem", lineHeight: 1.55 },
      "& a": { fontSize: "0.875rem" },
    }}
  >
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        gap: 0.5,
      }}
    >
      <Typography
        component="div"
        sx={{
          color: "custom.ink",
          flexGrow: 1,
        }}
      >
        <SpanTypography
          variant="h4"
          sx={{
            fontSize: "1rem",
            fontWeight: 700,
            mr: 0.25,
            textDecoration: "underline",
          }}
        >
          {howTociteDictionary}
        </SpanTypography>
        <SpanTypography>{data.how_to_cite}</SpanTypography>
      </Typography>
      <CopyCitationButton
        text={data.how_to_cite}
        sx={{ color: "custom.link" }}
      />
    </Box>
  </Panel>
);

export default HowToCite;
